<script setup lang="ts">
import { UploadViewDataQuery } from '@/generated/graphql'
import { useI18n } from 'vue-i18n'
import UploadUsageLocationBreadcrumb from '@/components/upload/UploadUsageLocationBreadcrumb.vue'
import useAsyncDialog from '@/components/dialogs/useAsyncDialog'

type UsageLocation = UploadViewDataQuery['upload']['search'][0]['usageLocations'][0]

defineProps<{
  usageLocations: UsageLocation[]
  uploadId: string
}>()

const { t } = useI18n()
const { openAsyncDialog, asyncDialogResolve, asyncDialogIsOpen } =
  useAsyncDialog<() => Promise<void>>()

const open = async () => {
  return openAsyncDialog()
}

defineExpose({ open })
</script>

<template>
  <v-dialog v-if="asyncDialogResolve" v-model="asyncDialogIsOpen" max-width="800" scrollable>
    <v-card>
      <v-card-title>
        {{ t('entity.upload.field.usageLocations') }}
        <v-btn
          density="compact"
          icon="close"
          class="float-right"
          variant="flat"
          @click="asyncDialogResolve()"
        />
      </v-card-title>
      <v-card-text>
        <v-list density="compact" variant="elevated">
          <template v-for="(location, index) in usageLocations" :key="index">
            <v-list-item>
              <template #prepend>
                <span class="text-caption text-grey mr-2">{{ index + 1 }}.</span>
              </template>
              <upload-usage-location-breadcrumb :location="location" />
            </v-list-item>
            <v-divider v-if="index < usageLocations.length - 1" thickness="2" />
          </template>
          <v-list-item v-if="usageLocations.length === 0" class="text-grey">
            {{ t('entity.upload.usageLocations.none') }}
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="asyncDialogResolve()">
          {{ t('button.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss"></style>
